import { forwardRef, memo } from 'react';
import TextField from '@mui/material/TextField';
import { useIsVisible } from 'root/src/client/v2/common/hooks/useIsVisible';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
// @ts-ignore
export const PasswordInput = memo(forwardRef((props, ref) => {
    const { isVisible, toggle } = useIsVisible(false);
    return (<TextField {...props} ref={ref} type={isVisible ? 'text' : 'password'} InputProps={Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.InputProps), { endAdornment: (<Tooltip title={isVisible ? 'Hide' : 'Show'} placement="top" arrow>
						<IconButton type="button" title={isVisible ? 'Hide' : 'Show'} tabIndex={-1} onClick={toggle}>
							{isVisible ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</Tooltip>) })}/>);
}));
